module.exports = __webpack_public_path__ + "img/RMRGreen_Logo.177fca79.png";